<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="$vuetify.rtl"
    :src="drawerImage ? image : ''"
    :mini-variant.sync="mini"
    mini-variant-width="80"
    app
    width="260"
  >
    <template
      v-if="drawerImage"
      #img="props"
    >
      <v-img
        :key="image"
        :gradient="gradient"
        v-bind="props"
      />
    </template>

    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <default-list :items="items" />
    </div>

    <template #append>
      <div class="pa-4 text-center">
        <app-btn
          block
          class="text-none mb-2"
          color="secondary"
          href="#"
        >
          <v-icon left>
            mdi-package-up
          </v-icon>

          تنطیمات سایت
        </app-btn>
        <app-btn
          block
          class="text-none"
          color="secondary"
          href="#"
          @click="dialogBackup = true"
        >
          <v-icon left>
            mdi-package-up
          </v-icon>
          تهیه و بازگردانی پشتیبان
        </app-btn>
      </div>
    </template>

    <div class="pt-12" />
    <v-dialog
      v-model="dialogBackup"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">پشتیبان گیری</span>
          <v-spacer />
          <v-btn
            icon
            @click="dialogBackup = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <app-backup
              v-if="dialogBackup"
              ref="backups"
              :data="selectedUser"
              @callbck="callbck_backup"
            />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
// Utilities
  import { get, sync } from 'vuex-pathify'
  import AppBackup from '@/views/admin/AppBackup.vue'

  export default {
    name: 'DefaultDrawer',

    components: {
      DefaultDrawerHeader: () =>
      import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
      DefaultList: () =>
      import(
        /* webpackChunkName: "default-list" */
        './List'
      ),
      'app-backup': AppBackup,
    },
    data () {
      return {
        dialogBackup: false,
        selectedUser: {},
      }
    },
    computed: {
      ...get('user', ['dark', 'gradient', 'image']),
      ...get('app', ['items', 'version']),
      ...sync('app', ['drawer', 'drawerImage', 'mini']),
    },
    methods: {
      callbck_backup () {
        this.dialogBackup = false
      },
    },
  }
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
